import { useEffect } from 'react';
import { trackPageView } from '@/lib/analytics';

/**
 * Hook to automatically track page views
 */
export function usePageTracking(pageName: string) {
  useEffect(() => {
    trackPageView(pageName);
  }, [pageName]);
}
